import { Route, Redirect } from 'react-router-dom';

// See: https://blog.netcetera.com/how-to-create-guarded-routes-for-your-react-app-d2fe7c7b6122
const GuardedRoute = ({ component: Component, auth, ...rest }) => (
  <Route {...rest} render={(props) => (auth ? <Component {...props} /> : <Redirect to="/" />)} />
);

export default GuardedRoute;
